// src/layouts/users/data/usersTableData.js
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import AddUserModal from "components/AddUserModal";
import axios from "axios";
import Swal from "sweetalert2";
import { Person as PersonIcon } from "@mui/icons-material"; // أضف هذا الاستيراد
const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: theme.palette.success.main,
    "&:hover": {
      backgroundColor: theme.palette.success.light,
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: theme.palette.success.main,
  },
}));
export default function ordersDetailsTableData(items) {
  return {
    columns: [
      { Header: "الصورة", accessor: "image", align: "center" },
      { Header: "اسم المنتج", accessor: "product_name", align: "center" },
      { Header: "الكمية", accessor: "quantity", align: "center" },
      { Header: "السعر", accessor: "price", align: "center" },
      { Header: "المتغيرات المختارة", accessor: "attributes", align: "center" },
    ],
    rows: items.map((item) => {
      // صورة المنتج: من product.medias أو product_variant.image
      let image = item.product_variant?.image || (item.product?.medias?.[0]?.file_name ?? "");
      let name = item.product?.name || "-";
      let attributes = [];
      if (item.product_variant?.product_attributes) {
        // نجمع المتغيرات بحيث كل متغير يظهر مرة واحدة مع القيم المختارة
        const attrMap = {};
        item.product_variant.product_attributes.forEach((attrObj) => {
          const attrName = attrObj.attribute_value.attribute.name;
          const attrValue = attrObj.attribute_value.value;
          if (!attrMap[attrName]) {
            attrMap[attrName] = new Set();
          }
          attrMap[attrName].add(attrValue);
        });
        attributes = Object.entries(attrMap).map(
          ([attrName, values]) => `${attrName}: ${Array.from(values).join(", ")}`
        );
      }
      return {
        image: (
          <MDAvatar
            src={image}
            alt={name}
            size="sm"
            sx={{ width: 60, height: 60, borderRadius: 2 }}
            variant="rounded"
          />
        ),
        product_name: (
          <MDTypography
            variant="caption"
            fontWeight="bold"
            title={name}
            sx={{
              maxWidth: 120,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              display: "inline-block",
              verticalAlign: "middle",
              cursor: "pointer",
            }}
          >
            {name}
          </MDTypography>
        ),
        quantity: <MDTypography variant="caption">{item.quantity}</MDTypography>,
        price: <MDTypography variant="caption">{item.price}</MDTypography>,
        attributes:
          attributes.length > 0 ? (
            <MDBox>
              {attributes.map((attr, idx) => (
                <MDTypography key={idx} variant="caption" display="block">
                  {attr}
                </MDTypography>
              ))}
            </MDBox>
          ) : (
            <MDTypography variant="caption" sx={{ color: "red !important" }}>
              لا يوجد متغيرات
            </MDTypography>
          ),
      };
    }),
  };
}
